import { render, staticRenderFns } from "./requestResearch.vue?vue&type=template&id=14cd2759&"
import script from "./requestResearch.vue?vue&type=script&lang=js&"
export * from "./requestResearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports